// tipo: 'taller' | 'exhibicion' | 'desfile'
const agenda = [
  {
    dia: 'Sábado 17 de octubre',
    items: [
      { hora: '10:30', duracion: '30 min', tipo: 'exhibicion', titulo: 'Exhibición unidad canina SENASICA' },
      { hora: '11:00', duracion: '30 min', tipo: 'exhibicion', titulo: 'Exhibición unidad canina PEMEX' },
      { hora: '11:30', duracion: '30 min', tipo: 'exhibicion', titulo: 'Exhibición unidad canina Cruz Roja' },
      { hora: '12:00', duracion: '1 hora', tipo: 'taller', titulo: 'Enseña a tu perro a estar en un lugar pet friendly', ponente: 'Monse Valdez' },
      { hora: '13:00', duracion: '30 min', tipo: 'exhibicion', titulo: 'Exhibición unidad canina SENASICA' },
      { hora: '13:30', duracion: '1 hora', tipo: 'taller', titulo: '¿Por qué hace eso mi perro?', ponente: 'Ana Paula Cañizares' },
      { hora: '14:30', duracion: '30 min', tipo: 'exhibicion', titulo: 'Exhibición unidad canina PEMEX' },
      { hora: '15:00', duracion: '1 hora', tipo: 'taller', titulo: 'Estimulación mental y reciclaje', ponente: 'Claudia Edwards' },
      { hora: '16:00', duracion: '30 min', tipo: 'exhibicion', titulo: 'Exhibición unidad canina Cruz Roja' },
      { hora: '16:30', duracion: '30 min', tipo: 'desfile', titulo: 'Desfile perros en adopción', ponente: 'Asociaciones perros en adopción' },
    ],
  },
  {
    dia: 'Domingo 18 de octubre',
    items: [
      { hora: '10:30', duracion: '30 min', tipo: 'exhibicion', titulo: 'Exhibición unidad canina Cruz Roja' },
      { hora: '11:00', duracion: '30 min', tipo: 'exhibicion', titulo: 'Exhibición unidad canina SENASICA' },
      { hora: '11:30', duracion: '30 min', tipo: 'exhibicion', titulo: 'Exhibición unidad canina PEMEX' },
      { hora: '12:00', duracion: '1 hora', tipo: 'taller', titulo: 'Aprende a revisar el peso ideal de tu gato', ponente: 'Edgar Islas' },
      { hora: '13:00', duracion: '30 min', tipo: 'exhibicion', titulo: 'Exhibición unidad canina Cruz Roja' },
      { hora: '13:30', duracion: '1 hora', tipo: 'taller', titulo: 'Botiquín de primeros auxilios para tu perro y gato', ponente: 'Adrián Alba' },
      { hora: '14:30', duracion: '30 min', tipo: 'exhibicion', titulo: 'Exhibición unidad canina SENASICA' },
      { hora: '15:00', duracion: '1 hora', tipo: 'taller', titulo: 'Tuina para perros: presiona, conecta y equilibra', ponente: 'LomBom' },
      { hora: '16:00', duracion: '30 min', tipo: 'exhibicion', titulo: 'Exhibición unidad canina PEMEX' },
      { hora: '16:30', duracion: '30 min', tipo: 'desfile', titulo: 'Desfile perros en adopción', ponente: 'Asociaciones perros en adopción' },
    ],
  },
];

export default agenda;
